import React from "react";
import HeaderAny from "../components/header";
import MobileNav from "../components/header-mobile";
import PubHero from "../components/published/pub-hero";
import SocialProof from "../components/home/trusted";
import PubTrustLayers from "../components/published/pub-trust-layers";
import PubShowcase from "../components/published/pub-showcase";
import PubSolutions from "../components/published/pub-solutions";
import PubStats from "../components/published/pub-stats";
import PubVerification from "../components/published/pub-verification";
import AuthenticityBanner from "./authenticity_banner";
import PubIndustries from "../components/published/pub-industries";
import PubPowering from "../components/published/pub-powering";
import PricingTestimonials from "../components/pricing/pricing-testimonials";
import PubJoinCTA from "../components/published/pub-join-cta";
import PubNotBanner from "../components/published/pub-not-banner";
import PubContact from "../components/published/pub-contact";
import Footer from "../components/footer";

const PublishedLanding = () => (
    <div>
        <div className="web-only">
            <HeaderAny />
        </div>
        <div className="mobile-only">
            <MobileNav />
        </div>

        <PubHero />
        <SocialProof />
        <PubTrustLayers />
        <PubSolutions />
        <PubShowcase />
        {/* <PubStats /> */}
        <PubVerification />
        {/* <PubNotBanner /> */}
        {/* <AuthenticityBanner /> */}
        {/* <PubIndustries /> */}
        {/* <PubPowering /> */}

        {/* Testimonials heading + cards */}
        {/* <div className="pricing-testimonial-heading">
            <p className="pricing-testimonial-italic">What our client say</p>
            <h2 className="pricing-testimonial-title">Trusted by Global Leaders</h2>
        </div>
        <PricingTestimonials /> */}

        {/* <PubJoinCTA /> */}
        <PubContact />
        <Footer />
    </div>
);

export default PublishedLanding;
